/* eslint-disable jira/filename-case */

import { di } from 'react-magnetic-di';
import { JSW_TMP_BACKLOG_BOARD_REGEXP } from '@jira/navigation-apps__atlassian-navigation-ui/src/constants.tsx';

export const shouldDisableGICFlagCreation: () => boolean = () => {
	di(window);
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	return JSW_TMP_BACKLOG_BOARD_REGEXP.test(window.location.pathname);
};
